/**
 * SECONDARY TRIGGER
 * Pure rule shared by the template editor and the project checks (no import, easy to test)
 */

interface TriggerQuestion {
  type: string
  draft?: boolean
  options?: { multipleItems?: boolean }
  Propositions?: { id: string }[]
  QuestionsTopic?: { triggerChoice?: string | null }
}

//Secondary questions under a single choice question (QCM). In the questionnaire (qv) :
// - no trigger choice : the secondary question is asked to everyone
// - a trigger choice that is not among the propositions of the primary : it is never asked
//Draft questions are not part of the questionnaire yet : nothing to report
export function getSecondaryTriggerIssues<T extends TriggerQuestion>(
  primary: TriggerQuestion | null | undefined,
  secondaries: T[]
): { neverTriggered: T[]; alwaysAsked: T[] } {
  const result = { neverTriggered: [] as T[], alwaysAsked: [] as T[] }
  if (!primary || primary.draft || primary.type !== "choice" || primary.options?.multipleItems) return result

  const propositionIds = (primary.Propositions || []).map((x) => x.id)
  secondaries
    .filter((x) => !x.draft)
    .forEach((x) => {
      const choice = x.QuestionsTopic?.triggerChoice
      if (!choice) {
        result.alwaysAsked.push(x)
      } else if (!propositionIds.includes(choice)) {
        result.neverTriggered.push(x)
      }
    })
  return result
}
